<template>
  <v-main>
    <v-container fluid>
      <v-row align="center" justify="center">
      <v-data-table
        :headers="headers"
        fixed-header
        height="50vh"
        :items="orders"
        :loading="loading"
        :search="search"
        :sort-desc="[false, true]"
        multi-sort
        dark
        dense
        class="table"
        item-key="email"
        scope="props"
      >
        <template v-slot:top>
          <v-toolbar flat dark rounded>
            <v-toolbar-title>Orders</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <export-excel :data="localOrders" name="users">
              <v-btn color="primary"><v-icon color="white">mdi-file-download</v-icon></v-btn>
            </export-excel>
          </v-toolbar>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ item.amount | brl }}
        </template>
        <template v-slot:[`item.cart`]="{ item }">
          <span @click="openCartDialog(item.cart)"><a>Open</a></span>
           <v-dialog v-model="cartDialog._enabled" max-width="300" :retain-focus="false">
            <v-container>
              <v-row class="flex-column mb-3" v-for="(_item, i) in item.cart" :key="i">
                <div class="d-flex">Product: <span class="ml-auto gold">{{ _item.name }}</span></div>
                <div class="d-flex">Quantity: <span class="ml-auto gold">{{ _item.quantity }}</span></div>
                <div class="d-flex">Value: <span class="ml-auto gold">{{ _item.value }}</span></div>
                <div class="d-flex">Type: <span class="ml-auto gold">{{ _item.type }}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.payment`]="{ item }">
          <span @click="openPaymentDialog(item.payment)"><a>Open</a></span>
          <v-dialog v-model="paymentDialog._enabled" max-width="300" :retain-focus="false">
            <v-container>
              <v-row class="flex-column">
                <div class="d-flex">Method: <span class="ml-auto gold">{{ item.payment.method }}</span></div>
                <div class="d-flex">Installments: <span class="ml-auto gold">{{ item.payment.installments }}</span></div>

                <div class="d-flex mt-4"><span class="ml-auto gold">Card</span></div>
                <div class="d-flex">Last Four: <span class="ml-auto gold">{{ item.payment.lastFour }}</span></div>
                <div class="d-flex">Holder Name: <span class="ml-auto gold">{{ item.payment.holderName }}</span></div>
                <div class="d-flex">Exp Year: <span class="ml-auto gold">{{ item.payment.expirationYear }}</span></div>
                <div class="d-flex">Brand: <span class="ml-auto gold">{{ item.payment.brand }}</span></div>

              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.buyer`]="{ item }">
          <span @click="openBuyerDialog(item.buyer)"><a>Open</a></span>
          <v-dialog v-model="buyerDialog._enabled" max-width="300" :retain-focus="false">
            <v-container>
              <v-row class="flex-column">
                <div class="d-flex">Name: <span class="ml-auto gold">{{ item.buyer.firstname || '' }}</span></div>
                <div class="d-flex">Surname: <span class="ml-auto gold">{{ item.buyer.lastname|| '' }}</span></div>
                <div class="d-flex">Email: <span class="ml-auto gold">{{ item.buyer.email|| '' }}</span></div>
                <div class="d-flex">Cpf: <span class="ml-auto gold">{{ item.buyer.cpf || '' }}</span></div>
                <div class="d-flex mt-3"><span class="ml-auto gold">Address</span></div>
                <div class="d-flex">Postal Code: <span class="ml-auto gold">{{ item.buyer.address.postalCode || '' }}</span></div>
                <div class="d-flex">Street: <span class="ml-auto gold">{{ item.buyer.address.street || '' }}</span></div>
                <div class="d-flex">Number: <span class="ml-auto gold">{{ item.buyer.address.number || '' }}</span></div>
                <div class="d-flex">Complement: <span class="ml-auto gold">{{ item.buyer.address.complement || ''}}</span></div>
                <div class="d-flex">District: <span class="ml-auto gold">{{ item.buyer.address.district || ''}}</span></div>
                <div class="d-flex">City: <span class="ml-auto gold">{{ item.buyer.address.city || ''}}</span></div>
                <div class="d-flex">State: <span class="ml-auto gold">{{ item.buyer.address.state || ''}}</span></div>
              </v-row>
            </v-container>
          </v-dialog>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <span>{{ formatDate(item) }}</span>
        </template>
      </v-data-table>
      </v-row>
    </v-container>
  </v-main>
</template>

<style lang="scss">
  .table {
    width: 85%;
    .search {
      margin-right: 25px;
      max-width: 300px;
    }
  }
  th {
    span { font-size: 15px; }
    color: gold !important;
  }
  .v-dialog { box-shadow: none !important; }
  .large { min-width: 125px; }
  .gold { color: gold; }
  .pointer { cursor: pointer; }
</style>

<script>
/* eslint-disable */
import { upperCaseFirstLetter } from '@/utils/strings'
import { formatDate } from '@/utils/date'
import { mapGetters } from 'vuex'

const translatedTableTitles = {}
const translatedTableFields = {}
const translatedGeneralWordsAndPhrases = {}

const hiddenTableColumns = ['id', 'link', 'references', 'notifications']

export default {
  name: 'Orders',
  data () {
    return {
      loading: true,
      search: '',
      headers: [],
      localOrders: [],
      cartDialog: {
        _enabled: false,
        items: []
      },
      paymentDialog: {
        _enabled: false, 
        method: '',
        installments: 0,
        card: {
          lastFour: '',
          HolderName: '',
          ExpirantionYear: '',
          brand: ''
        },
        boleto: {
          barcode: '',
          link: '',
          expirationDate: '',
        },
        status: '',
        paidAt: '',
        tax: 0,
      },
      buyerDialog: {
        _enabled: false,
        firstname: '',
        lastname: '',
        email: '',
        cpf: '',
        address: {
          postalCode: '',
          street: '',
          number: '',
          complement: '',
          city: '',
          state: ''
        }
      }
    }
  },
  mounted () {
    let headerCreated = false
    let order = {}
    this.loading = true 
    this.$store.watch(
      state => state.orders,
      orders => {
        this.loading = false
        orders.forEach(_order => {
          if (!headerCreated) {
            for (const key of Object.entries(_order)) {        
              if (key[0] === 'buyer') {
                this.headers.push(
                  { text: 'Buyer Name', value: 'buyer.firstname' },
                  { text: 'Buyer Email', value: 'buyer.email' }
                )
              }
                 
              this.headers.push({ text: upperCaseFirstLetter(key[0]), value: key[0], class: 'large', align: hiddenTableColumns.includes(key[0]) ? ' d-none' : '' })
            }
              
            headerCreated = true;
          }
          order = {}
          for (const key of Object.entries(_order)) {  
            order = { ...order, [key[0]]: key[1] }
          }
          this.localOrders.push(order)
        });
         this.loading = false
      },
      { deep: true }
    )   
  },
  computed: {
    //formTitle () { return this.configDialog.itemIndex === -1 ? 'Include Config' : 'Edit Config' }
    ...mapGetters(['orders'])
  },
  methods: {
     openCartDialog (items) {
      this.cartDialog = { _enabled: true, items }
    },
    openPaymentDialog (payment) {
      this.paymentDialog = { _enabled: true, ...payment }
    },
     openBuyerDialog (items) {
      this.buyerDialog = { _enabled: true, items }
    },
    translateTableTitle (word) { return (word in translatedTableTitles) ? translatedTableTitles[word] : word },
    translateTableField (word) { return (word in translatedTableFields) ? translatedTableFields[word] : word },
    translateGeneralWordsAndPhrases (expression) { return (expression in translatedGeneralWordsAndPhrases) ? translatedGeneralWordsAndPhrases[expression] : expression },
    formatDate(date) { return formatDate(date) }    
  },
}
</script>